import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import {
  ProfessionalsPage,
  type ProfessionalsParams,
} from '@/features/services/professionals-page';

const searchSchema = z.object({
  q: z.string().optional().catch(undefined),
  trade: z.string().optional().catch(undefined),
  county: z.string().optional().catch(undefined),
  town: z.string().optional().catch(undefined),
  availability: z.enum(['site_work', 'jobs']).optional().catch(undefined),
  min_rating: z.coerce.number().optional().catch(undefined),
  verified: z.coerce.boolean().optional().catch(undefined),
  price_band: z.string().optional().catch(undefined),
  type: z.enum(['individual', 'company']).optional().catch(undefined),
  sort: z.enum(['rating', 'name']).optional().catch(undefined),
  page: z.coerce.number().int().positive().optional().catch(undefined),
});

/** Marketplace › Professionals: people and companies together, paged on the server. */
export const Route = createFileRoute('/_app/marketplace/professionals')({
  validateSearch: searchSchema,
  component: ProfessionalsRoute,
});

function ProfessionalsRoute() {
  const params = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <ProfessionalsPage
      params={params}
      onChange={(next: ProfessionalsParams) => void navigate({ search: next, replace: true })}
    />
  );
}
